module.exports = __webpack_public_path__ + "static/media/schoolshoppinglist2.5e26a87e.jpg";